import React from 'react';
export const Conservas = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg"  version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" width="512px" height="512px"><g><g>
	<g>
		<path d="M426.259,146.768L378.507,102H386c8.284,0,15-6.716,15-15V15c0-8.284-6.716-15-15-15H126c-8.284,0-15,6.716-15,15v72    c0,8.284,6.716,15,15,15h7.493l-47.752,44.768C82.716,149.604,81,153.564,81,157.711V467c0,24.813,20.187,45,45,45h260    c24.813,0,45-20.187,45-45V157.711C431,153.564,429.284,149.604,426.259,146.768z M181,412.355c0,8.284-6.716,15-15,15    s-15-6.716-15-15v-200c0-8.284,6.716-15,15-15s15,6.716,15,15V412.355z M361,412.355c0,8.284-6.716,15-15,15s-15-6.716-15-15v-200    c0-8.284,6.716-15,15-15s15,6.716,15,15V412.355z" data-original="#000000" data-old_color="#000000" fill="#0D1137"/>
	</g>
</g></g> </svg>  );
};
